import {
  useGetUserCollaborativeGroupWorks,
  useDeleteCollaborativeGroupWork,
  getGetUserCollaborativeGroupWorksQueryKey,
  useGetTopCollaborativeGroupWorks,
  likeCollaborativeGroupWork,
  unlikeCollaborativeGroupWork,
  getGetTopCollaborativeGroupWorksQueryKey,
} from "@packages/api/madlenAPI";
import { CollaborativeGroupWorkResponseDto } from "@packages/api/madlenAPI.schemas";
import GenericToolPage from "../../components/tool_components/GenericToolPage";
import CollaborativeCard from "@features/tools/components/collaborative/CollaborativeCard";

const CollaborativeDetailComponent = ({
  tool,
}: {
  tool: CollaborativeGroupWorkResponseDto;
}) => {
  const collaborative = tool as CollaborativeGroupWorkResponseDto;
  return (
    <CollaborativeCard
      collaborative={collaborative}
      isEditable={tool.isEditable}
    />
  );
};

const CollaborativeView = () => {
  return (
    <GenericToolPage
      useGetTools={useGetUserCollaborativeGroupWorks}
      useDeleteTool={useDeleteCollaborativeGroupWork}
      getGetToolsQueryKey={getGetUserCollaborativeGroupWorksQueryKey}
      useGetTopTools={useGetTopCollaborativeGroupWorks}
      likeTool={likeCollaborativeGroupWork}
      unlikeTool={unlikeCollaborativeGroupWork}
      getGetTopToolsQueryKey={getGetTopCollaborativeGroupWorksQueryKey}
      toolType="collaborative"
      toolPath="collaborative"
      DetailComponent={CollaborativeDetailComponent}
      colors={{
        light: "from-[#E6C89C] to-[#D4A373]",
        dark: "dark:from-[#B08968] dark:to-[#7F5539]",
        iconBg: "bg-[#F5E0C3] dark:bg-[#6D4C3D]/30",
        iconColor: "text-[#C08457] dark:text-[#E6B089]",
        hover: "hover:bg-[#F0D9B5] dark:hover:bg-[#5C3D2E]/15",
      }}
      toolColor="[#C08457]"
      gradientColor="brown"
    />
  );
};

export default CollaborativeView;
